import { CLINICAL_BOOKING_DRAFT_TTL_MS } from "./clinicalBookingStates.mjs";

// src/models/consultation/clinicalAbandonedUnpaidHold.ts
/** Abandoned unpaid pre-provision consult — inverse of hub resume window for draft / hold rows. */
function isAbandonedUnpaidClinicalConsultation(consultation, now) {
	const status = consultation.lifecycleStatus;
	if (status === "draft") {
		if (consultation.createdAt.getTime() + 864e5 <= now.getTime()) return "draft_ttl";
		return null;
	}
	if (status === "reserved" || status === "payment_pending" || status === "ensuring_bridge_service") {
		if (!consultation.checkoutExpiresAt || consultation.checkoutExpiresAt.getTime() <= now.getTime()) return "hold_expired";
		return null;
	}
	return null;
}

export { isAbandonedUnpaidClinicalConsultation };
//# sourceMappingURL=clinicalAbandonedUnpaidHold.mjs.map